import React, { useState } from 'react';

// Service icons as SVG components
const PaletteIcon = () => (
  <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 21a4 4 0 01-4-4V5a2 2 0 012-2h4a2 2 0 012 2v12a4 4 0 01-4 4zM21 5a2 2 0 00-2-2h-4a2 2 0 00-2 2v12a4 4 0 004 4h4a2 2 0 002-2V5z" />
  </svg>
);

const LeafIcon = () => (
  <svg className="w-7 h-7" fill="currentColor" viewBox="0 0 24 24">
    <path d="M17 8C8 10 5.9 16.17 3.82 21.34l1.06.82C6.16 17.4 9 14.3 17 8zm3.5-2c-1.33 0-2.42 1.08-2.42 2.42 0 4.54-5.58 8.58-9.08 8.58v2c5.33 0 11.5-6.22 11.5-10.58 0-2.5-2.04-4.42-4.5-4.42z"/>
  </svg>
);

const DropletsIcon = () => (
  <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z" />
  </svg>
);

const WrenchIcon = () => (
  <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
  </svg>
);

const MountainIcon = () => (
  <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 3l4 6 2-3 8 14H1l4-17z" />
  </svg>
);

const LightbulbIcon = () => (
  <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
  </svg>
);

const ChevronDownIcon = () => (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
  </svg>
);

const SparklesIcon = () => (
  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
    <path d="M9.5 2l1.5 5L16 8.5 11 9.5 9.5 14 8 9.5 3 8.5 8 7.5 9.5 2zm6.5 7l.75 2.5L19 12.25l-2.25.75L16 15.5l-.75-2.5L13 12.25l2.25-.75L16 9zm-10 8l.5 1.5L8 19l-1.5.5L6 21l-.5-1.5L4 19l1.5-.5L6 17z"/>
  </svg>
);

const HeartIcon = () => (
  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
    <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>
  </svg>
);

const iconMap = {
  Palette: PaletteIcon,
  Leaf: LeafIcon,
  Droplets: DropletsIcon,
  Wrench: WrenchIcon,
  Mountain: MountainIcon,
  Lightbulb: LightbulbIcon
};

export default function ServiceCard({ service, index }) {
  const [isExpanded, setIsExpanded] = useState(false);
  const IconComponent = iconMap[service.icon];

  return (
    <div
      className={`bg-white/80 backdrop-blur-sm p-6 rounded-3xl shadow-lg border border-emerald-100 cursor-pointer hover:shadow-xl transition-all duration-500 hover:scale-105 hover:-translate-y-2 ${isExpanded ? 'scale-105' : ''}`}
      onClick={() => setIsExpanded(!isExpanded)}
      style={{
        animationDelay: `${index * 0.15}s`,
        opacity: 0,
        animation: `fadeInUp 0.6s ease forwards ${index * 0.15}s`
      }}
    >
      <div className="flex items-start justify-between mb-4">
        <div className="flex items-center gap-4">
          <div className="p-3 bg-gradient-to-br from-emerald-100 to-teal-100 rounded-2xl">
            <div className="text-emerald-600">
              <IconComponent />
            </div>
          </div>
          <div>
            <h3 className="text-xl font-semibold text-slate-800">{service.title}</h3>
            <p className="text-emerald-600 text-sm font-medium">Professional Service</p>
          </div>
        </div>
        <div
          className={`text-slate-400 transition-transform duration-300 ${isExpanded ? 'rotate-180' : ''}`}
        >
          <ChevronDownIcon />
        </div>
      </div>

      <p className="text-slate-600 mb-4 leading-relaxed">{service.text}</p>
      
      <div
        className={`overflow-hidden transition-all duration-400 ease-in-out ${
          isExpanded ? 'max-h-100 opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        <div className="pt-4 border-t border-emerald-100">
          <p className="text-slate-700 mb-4 leading-relaxed">{service.description}</p>
          
          <div className="mb-4">
            <h4 className="font-semibold text-slate-800 mb-3 flex items-center gap-2">
              <SparklesIcon />
              Key Features:
            </h4>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
              {service.features.map((feature, idx) => (
                <div key={idx} className="flex items-center gap-2">
                  <div className="w-2 h-2 bg-emerald-400 rounded-full"></div>
                  <span className="text-sm text-slate-600">{feature}</span>
                </div>
              ))}
            </div>
          </div>
          
          {/* <button className="w-full bg-gradient-to-r from-emerald-400 to-teal-500 hover:from-emerald-500 hover:to-teal-600 text-white font-medium py-3 px-6 rounded-2xl transition-all duration-300 flex items-center justify-center gap-2 btn-hover">
            <HeartIcon />
            Get Quote for {service.title}
          </button> */}
        </div>
      </div>
    </div>
  );
}

// Add keyframes for animations
const style = document.createElement('style');
style.textContent = `
  @keyframes fadeInUp {
    from {
      opacity: 0;
      transform: translateY(30px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;
document.head.appendChild(style);